import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "member-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-content" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { MD5 } from "crypto-js";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
	memberList,
	memberDel,
	memberRegister,
} from "@/common/api/rest/member";

import type { MemberType } from "@/common/types/member";

import { FormMember } from "@/components";
import {
	baseConfirm,
	baseModal,
	baseTable,
	breadcrumbSimple,
} from "@/common/components";

interface MemberRegisterType {
	name: string;
	login: string;
	email: string;
	birthdate: string;
	password: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();

const tableData = ref<MemberType[]>([]);
const selected = ref<MemberType | null>(null);
const payload = ref<MemberRegisterType | null>(null);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showModalAdd = ref(false);
const showModalDel = ref(false);
const payloadValid = ref(false);

const tableHeader = computed(() => [
	{ key: "name", label: t("common.labels.name") },
	{ key: "email", label: t("common.labels.email") },
	{ key: "status", label: t("common.labels.status") },
]);

const status = computed(() => ({
	ACTIVE: t("common.labels.active"),
	INACTIVE: t("common.labels.inactive"),
}));

const breadcrumbList = computed(() => [
	{
		key: "members",
		label: t("common.labels.members"),
		url: "/members",
	},
]);

function fetchData() {
	memberList({
		page: page.value,
		limit: limit.value,
		search: search.value,
	})
		.then((response) => {
			const { success, data, message } = response;

			if (success) {
				tableData.value = data.list;

				pages.value = data.infos.pages;
				total.value = data.infos.total;
				searched.value = data.infos.count;
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		});
}

function changePage(value: number) {
	page.value = value;
	fetchData();
}

function searchItem(value: string) {
	search.value = value;
	fetchData();
}

function editItem(data: MemberType) {
	router.push(`/members/${data.member_id}/edit`);
}

function removeItem(data: MemberType) {
	selected.value = data;
	showModalDel.value = true;
}

function removeItemCancel() {
	selected.value = null;
	showModalDel.value = false;
}

function removeItemConfirm() {
	if (!selected.value) return;

	store.commit("SET_LOADING", true);

	memberDel(selected.value.member_id)
		.then((response) => {
			const { success, message } = response;

			if (success) {
				toast({ message: message, type: "success" });
				removeItemCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

function addMember() {
	payload.value = null;
	showModalAdd.value = true;
	payloadValid.value = false;
}

function addMemberCancel() {
	payload.value = null;
	showModalAdd.value = false;
	payloadValid.value = false;
}

function addMemberConfirm() {
	if (!payload.value || !payloadValid.value) return;

	store.commit("SET_LOADING", true);

	memberRegister({
		...payload.value,
		login: payload.value.login.toLowerCase(),
		email: payload.value.email.toLocaleLowerCase(),
		password: MD5(payload.value.password).toString(),
	})
		.then((response) => {
			const { success, message } = response;
			if (success) {
				toast({ message: message, type: "success" });
				addMemberCancel();
				fetchData();
			} else {
				toast({ message: message, type: "error" });
			}
		})
		.catch(() => {
			toast({ message: t("error.default"), type: "error" });
		})
		.finally(() => {
			store.commit("SET_LOADING", false);
		});
}

onMounted(() => {
	fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("article", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createVNode(_unref(breadcrumbSimple), {
          items: breadcrumbList.value,
          "show-home": true,
          "url-home": "/home",
          active: "plans"
        }, null, 8, ["items"])
      ]),
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_unref(baseTable), {
          header: tableHeader.value,
          data: tableData.value,
          limit: limit.value,
          page: page.value,
          pages: pages.value,
          total: total.value,
          searched: searched.value,
          options: true,
          add: true,
          del: true,
          edit: true,
          "onBtn:add": _cache[0] || (_cache[0] = ($event: any) => (addMember())),
          "onChange:page": _cache[1] || (_cache[1] = ($event: any) => (changePage($event))),
          onSearching: _cache[2] || (_cache[2] = ($event: any) => (searchItem($event))),
          "onBtn:edit": _cache[3] || (_cache[3] = ($event: any) => (editItem($event))),
          "onBtn:del": _cache[4] || (_cache[4] = ($event: any) => (removeItem($event)))
        }, {
          status: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(status.value[data.status]?.toUpperCase()), 1)
          ]),
          name: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.name), 1)
          ]),
          _: 1
        }, 8, ["header", "data", "limit", "page", "pages", "total", "searched"])
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: _unref(t)('member.modals.titles.member_add').toUpperCase(),
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[7] || (_cache[7] = ($event: any) => (addMemberCancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (addMemberConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(FormMember), {
          data: selected.value,
          "is-edit": false,
          "onUpdate:data": _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event)),
          onValidate: _cache[6] || (_cache[6] = ($event: any) => (payloadValid.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('member.modals.titles.member_remove').toUpperCase(),
      message: 
			_unref(t)('member.modals.messages.member_remove', {
				name: selected.value?.first_name,
			})
		,
      onCancel: _cache[9] || (_cache[9] = ($event: any) => (removeItemCancel())),
      onConfirm: _cache[10] || (_cache[10] = ($event: any) => (removeItemConfirm()))
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})